import { put, takeLatest } from "redux-saga/effects";
import { postUploadImageProfileApi } from "store/api/InfomationStoreApi";
import { UPLOAD_IMAGE_PROFILE_ACTION } from "../../actions/InfomationStorePageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postUploadImageProfile(action) {
	const { files, onSuccess } = action.params;
	const res = yield postUploadImageProfileApi(files);
	try {
		if (res?.code === 0) {
			onSuccess(res?.data?.link);
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* postUploadImageProfileSaga() {
	yield takeLatest(UPLOAD_IMAGE_PROFILE_ACTION, postUploadImageProfile);
}

export default postUploadImageProfileSaga;
